import { render, staticRenderFns } from "./ProfileDetailItem.vue?vue&type=template&id=217ec990&scoped=true&"
import script from "./ProfileDetailItem.vue?vue&type=script&lang=js&"
export * from "./ProfileDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetailItem.vue?vue&type=style&index=0&id=217ec990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ec990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCol,VIcon,VListItem,VListItemIcon,VRow,VTextField})
